// External libraries
import React from 'react';

// Internal modules
import { useMountLogging } from '@/lib/reactHooks';
import { DisabledMaskContainer } from './StyledComponents';

interface DisabledMaskProps {
  isDisabled?: boolean;
  children: React.ReactNode;
}

const DisabledMask: React.FC<DisabledMaskProps> = ({
  isDisabled = false,
  children,
}) => {
  useMountLogging('DisabledMask');

  if (!isDisabled) {
    return <>{children}</>;
  }

  return (
    <DisabledMaskContainer data-testid="disabled-mask-container" disabled>
      {children}
    </DisabledMaskContainer>
  );
};

export { DisabledMask };
